import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { HIS_TYPE_OPTIONS } from '@/pages/Onboarding/options/HisType/HIS_TYPE_OPTIONS';
import { getHisTypeTitleById } from '@/pages/Onboarding/options/HisType/utils/getHisType';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const HisTypeScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'HisType',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const hisType = form.watch('his_type');

  const handleSelect = (option: OnbOptionType<LayoutDataType['his_type']>) => {
    form.setValue('his_type', option.id);
  };

  const handleNextStep = () => {
    const hisTypeTitle = getHisTypeTitleById(hisType);
    userService.createOrUpdate({
      onboarding_data: {
        his_type: hisTypeTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>What's His Type?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="grid">
          {HIS_TYPE_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={hisType === option.id}
              control={form.control}
              option={option}
              name="his_type"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="grid"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!hisType}
      />
    </OnboardingPage>
  );
};
